import { useMemo } from 'react';

export interface LoginFormData {
  email: string;
}

const useInitialValues = () =>
  useMemo(
    (): LoginFormData => ({
      email: '',
    }),
    [],
  );

export default useInitialValues;
